import { ShowErrorModel } from '@bo-client/shared/form-errors/errors-form-model';

export enum ErrorFormsEnum {
  mandatory = ' ist erforderlich.',
  mandatoryPlural = ' sind erforderlich.',
  mandatoryMinLength6 = ' ist erforderlich und muss mindestens 6 Stellen haben.',
  greaterThanZero = ' muss größer als 0 sein.',
  max600Watt = ' darf nicht größer als 0.6 kW sein.',
  max800Watt = ' darf nicht größer als 0.8 kW sein.',
  mandatoryAndGreaterThanZero = ' ist erforderlich und muss größer als 0 sein.',
  notValid = ' ist nicht gültig.',
  cancel = ' Manueller Antrag ist nötig.'
}

export enum ErrorStepsEnum {
  None = 'None',
  GisData = 'GisData',
  Filiation = 'Filiation',
  GridRegistrationType = 'GridRegistrationType',
  MeterConcept = 'MeterConcept',
  MeterNumber = 'MeterNumber',
  Producer = 'Producer',
  FeedinManagementInfo = 'FeedinManagementInfo',
  Consumer = 'Consumer',
  Storage = 'Storage',
  PVModule = 'PVModule',
  MoreInfo = 'MoreInfo',
  Conditions = 'Conditions'
}

export const ErrorFormCommissioningEnum: ShowErrorModel[] = [
  {
    controlName: 'supplyAppointment.date',
    displayName: 'Durchführungstermin',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'meterOperatorBDEWCode',
    displayName: 'Messstellenbetreiber',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'supplyAppointment.time',
    displayName: 'Durchführungstermin',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'supplyAppointment.supplyAppointmentWishDate',
    displayName: 'Datum des Wunschtermins',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'supplyAppointment.supplyAppointmentWishPartday',
    displayName: 'Tageszeit des Wunschtermins',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'supplyAppointmentWishPartday',
    displayName: 'Tageszeit des Wunschtermins',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'filiationData.salutation',
    displayName: 'Anrede',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'filiationData.firstName',
    displayName: 'Vorname',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'chimneySweepMail',
    displayName: 'E-Mail-Adresse des zuständigen Bezirksschornsteinfegers',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'filiationData.company',
    displayName: 'Name der Firma',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'filiationData.lastName',
    displayName: 'Nachname',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'filiationData.phone',
    displayName: 'Telefonnummer',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'filiationData.mail',
    displayName: 'E-Mail',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'filiationData.phone',
    displayName: 'Telefon',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'filiationData.street',
    displayName: 'Straße',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'filiationData.streetNo',
    displayName: 'Hausnummer',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'filiationData.zipCode',
    displayName: 'PLZ',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'filiationData.city',
    displayName: 'Ort',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'salutation',
    displayName: 'Anrede',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'firstName',
    displayName: 'Vorname',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'company',
    displayName: 'Name der Firma',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'lastName',
    displayName: 'Nachname',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'phone',
    displayName: 'Telefonnummer',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'mail',
    displayName: 'E-Mail',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'phone',
    displayName: 'Telefon',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'street',
    displayName: 'Straße',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'streetNo',
    displayName: 'Hausnummer',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'zipCode',
    displayName: 'PLZ',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'city',
    displayName: 'Ort',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'district',
    displayName: 'Ortsteil',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Filiation
  },
  {
    controlName: 'acceptConditions.installationCorrectlyExecuted',
    displayName: 'Ausführung der Anlage: ',
    errorMessage: 'Akzeptieren Sie bitte die Bedingungen zur Ausführung der Anlage',
    step: ErrorStepsEnum.Conditions
  },
  {
    controlName: 'acceptConditions.ownerConsent',
    displayName: 'Zustimmung des Eigentümers: ',
    errorMessage: 'Akzeptieren Sie bitte die Bedingungen zur Zustimmung des Eigentümers ',
    step: ErrorStepsEnum.MoreInfo
  },
  {
    controlName: 'actions.provisionalNeededUntil',
    displayName: 'Bauwasserzähler benötigt bis: ',
    errorMessage: 'Bitte geben Sie ein Datum an',
    step: ErrorStepsEnum.Conditions
  },
  {
    controlName: 'acceptConditions.chimneySweepConfirmation',
    displayName: 'Zustimmung des Schornsteinfeger: ',
    errorMessage: 'Bestätigen Sie bitte die Zustimmung des Schornsteinfegers',
    step: ErrorStepsEnum.Conditions
  },
  {
    controlName: 'connectionObject.streetNo',
    displayName: 'Objektadresse',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.GisData
  },
  {
    controlName: 'connectionObject.corridorNumber',
    displayName: 'Objektadresse',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.GisData
  },
  {
    controlName: 'companyLocation',
    displayName: 'Anschlussobjekt und Betriebsbereich',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.GisData
  },
  {
    controlName: 'signedDocument.url',
    displayName: 'Das vom Schornsteinfeger unterschriebene Dokument',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'firstDateAvailable',
    displayName: 'Datumsangabe des Wunschtermins',
    errorMessage: ErrorFormsEnum.notValid
  },
  {
    controlName: 'actions.regulatorAlreadyExits',
    displayName: "Angabe zu 'Regler vorhanden'",
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'actions.meterNumber',
    displayName: 'Zählernummer',
    errorMessage: ErrorFormsEnum.mandatoryMinLength6
  },
  {
    controlName: 'actions.sealingNecessary',
    displayName: "Angabe zu 'Gaszähler verplombt'",
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'actions.actionType',
    displayName: 'Art der durchzuführenden Aktion',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'actions.devices',
    displayName: 'Geräte',
    errorMessage: ErrorFormsEnum.mandatoryPlural
  },
  {
    controlName: 'actions.newDevice',
    displayName: 'Informationen zum neuen Zähler',
    errorMessage: ErrorFormsEnum.mandatoryPlural
  },
  {
    controlName: 'actions.existingDevice',
    displayName: 'Informationen zum alten Zähler',
    errorMessage: ErrorFormsEnum.mandatoryPlural
  },
  {
    controlName: 'actions.expectedAnnualConsumption',
    displayName: 'Erwarteter Jahresverbrauch',
    errorMessage: ErrorFormsEnum.mandatoryAndGreaterThanZero
  },
  {
    controlName: 'actions.fixingType',
    displayName: 'Art der Befestigung',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'powerGenerationSource',
    displayName: 'Art der Erzeugungsanlage',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.GridRegistrationType
  },
  {
    controlName: 'hasInverterInstalled',
    displayName: 'Angabe zu bestehendem Wechselrichter',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.GridRegistrationType
  },
  {
    controlName: 'feedingPlantType',
    displayName: 'Anlageart der Erzeugungsanlage',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.GridRegistrationType
  },
  {
    controlName: 'meteringConcept',
    displayName: 'Messkonzept',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.MeterConcept
  },
  {
    controlName: 'storageConcept',
    displayName: 'Speicherkonzept',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'pvModules.type',
    displayName: 'Typ der PV-Module',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.PVModule
  },
  {
    controlName: 'pvModules.count',
    displayName: 'Anzahl der PV-Module',
    errorMessage: ErrorFormsEnum.mandatoryAndGreaterThanZero,
    step: ErrorStepsEnum.PVModule
  },
  {
    controlName: 'pvModules.modulePowerWatt',
    displayName: 'Einzelleistung der PV-Module',
    errorMessage: ErrorFormsEnum.mandatoryAndGreaterThanZero,
    step: ErrorStepsEnum.PVModule
  },
  {
    controlName: 'pvModules.exceedPower',
    displayName: 'Leider können wir Anlagen ab einer Einspeiseleistung von 135 kWp nicht digital erfassen.',
    errorMessage: ErrorFormsEnum.cancel,
    step: ErrorStepsEnum.PVModule
  },
  {
    controlName: 'producers.exceedPower',
    displayName: 'Leider können wir Anlagen ab einer Einspeiseleistung von 135 kWp nicht digital erfassen.',
    errorMessage: ErrorFormsEnum.cancel,
    step: ErrorStepsEnum.Producer
  },
  {
    controlName: 'producers.manufacturer',
    displayName: 'Hersteller der Erzeugungseinheit',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Producer
  },
  {
    controlName: 'producers.zerezId',
    displayName: 'ZEREZ-ID der Erzeugungseinheit',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Producer
  },
  {
    controlName: 'compensationType',
    displayName: 'Art der Vergütung',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.None
  },
  {
    controlName: 'feedInCompensationType',
    displayName: 'Art der Vergütung',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.None
  },
  {
    controlName: 'producers.count',
    displayName: 'Anzahl der Erzeugungseinheiten',
    errorMessage: ErrorFormsEnum.mandatoryAndGreaterThanZero,
    step: ErrorStepsEnum.Producer
  },
  {
    controlName: 'producers.deviceTypeName',
    displayName: 'Typ der Erzeugungseinheit',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Producer
  },
  {
    controlName: 'producers.phases',
    displayName: 'Anzahl der Phasen der Erzeugungseinheit',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Producer
  },
  {
    controlName: 'producers.connectedPhases',
    displayName: 'Angeschlossene Phasen der Erzeugungseinheit',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Producer
  },
  {
    controlName: 'producers.acActivePowerMax',
    displayName: 'AC- maximale Wirkleistung der Erzeugungseinheit',
    errorMessage: ErrorFormsEnum.mandatoryAndGreaterThanZero,
    step: ErrorStepsEnum.Producer
  },
  {
    controlName: 'feedInManagementInfo',
    displayName: 'Einspeisermanagement',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.FeedinManagementInfo
  },
  {
    controlName: 'storages.phases',
    displayName: 'Anzahl der Phasen der Speichers',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'storages.zerezId',
    displayName: 'ZEREZ-ID des Umrichters des Speichers',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'storages.manufacturer',
    displayName: 'Hersteller des Speichers',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'storages.count',
    displayName: 'Anzahl der Speicher',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'storages.usableCapacity',
    displayName: 'Nutzbare Speicherkapazität',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'storages.couplingType',
    displayName: 'Kopplungsart',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'storages.rotaryCurrent',
    displayName: 'Stromart',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'storages.networkAndDeviceProtection',
    displayName: 'NA-Schutz nach VDE-AR-N 4105',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'consumers.manufacturer',
    displayName: 'Hersteller des Verbraucher',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'consumers.noMeterPresent',
    displayName: "Angabe zu 'Zähler vorhanden'",
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'consumers.meterNumber',
    displayName: 'Zählernummer',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'consumers.chargerType',
    displayName: 'Ladesäulen-Typ',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'consumers.maLo',
    displayName: 'MaLo-Nummer',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'consumers.count',
    displayName: 'Anzahl des Verbraucher',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'consumers.power',
    displayName: 'AC maximale Wirkleistung',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'consumers.chargingPointsNumber',
    displayName: 'Anzahl der Ladepunkte insgesamt',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'consumers.location',
    displayName: 'Standort',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'consumers.heatPumpType',
    displayName: 'Art der Elektro-Wärmepumpe/-Raumkühlanlage',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'consumers.powerDIN',
    displayName: 'Leistungsangabe nach DIN 8900',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'consumers.maxStartingCurrent',
    displayName: 'Max. Leistungsaufnahme',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'consumers.maxConsumptionPower',
    displayName: 'Max. Anlaufstrom',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'consumers.switchingTime',
    displayName: 'Schaltzeiten E-Heizung/Wärmepumpe/Raumkühlanlage',
    errorMessage: ErrorFormsEnum.mandatoryPlural,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'existingFeeders.powerGenerationSource',
    displayName: 'Anzahl der Speicher',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.MoreInfo
  },
  {
    controlName: 'existingFeeders.power',
    displayName: 'Nutzbare Speicherkapazität',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.MoreInfo
  },
  {
    controlName: 'contractedConnectionPower',
    displayName: 'Vertragliche Grenzleistung',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'consumptionOver30kw',
    displayName: 'Maximaler Eigenverbrauch',
    errorMessage: ErrorFormsEnum.mandatory
  },

  /// FeederContract Errors
  {
    controlName: 'maStRNumberProducer',
    displayName: 'MaStR-Nr der Erzeugungseinheit',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'maStRNumberStorage',
    displayName: 'MaStR-Nr der Speichereinheit',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'maStRNumber',
    displayName: 'MaStR-Nr des Anlagenbetreibers der Einheit',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'maStRAcceptedDeclaration',
    displayName: 'Bedingungen des Marktstammdatenregisters',
    errorMessage: ErrorFormsEnum.mandatoryPlural
  },
  {
    controlName: 'companyInDistressCheck01',
    displayName: 'Angaben zu §19 Abs. 4 EEG 2023',
    errorMessage: ErrorFormsEnum.mandatoryPlural
  },
  {
    controlName: 'companyInDistressCheck02',
    displayName: 'Angaben zu §19 Abs. 4 EEG 2023',
    errorMessage: ErrorFormsEnum.mandatoryPlural
  },
  {
    controlName: 'maStRRegistrationDate',
    displayName: 'Datum der Registrierung',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'bankAccount.iban',
    displayName: 'SEPA-Daten IBAN',
    errorMessage: ErrorFormsEnum.mandatoryPlural
  },
  {
    controlName: 'plantOperatorAndEndUserAreIdentical',
    displayName: 'Anlagenbetreiber',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'acceptedUstConditions',
    displayName: 'Bedingungen der Umsatzsteuer',
    errorMessage: ErrorFormsEnum.mandatoryPlural
  },
  {
    controlName: 'acceptedSepa',
    displayName: 'SEPA Mandat',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'ustNrORtaxNr',
    displayName: 'Angabe zur Umsatzsteuer-Pflicht',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'meterOperator',
    displayName: 'Messstellenbetreiber',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'newProduction',
    displayName: 'Maximale Scheinleistung',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'newInstalledPower',
    displayName: 'Installierte Modulleistung',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'commissioningDate',
    displayName: 'Inbetriebsetzungsdatum (Weitere Daten)',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'acceptedConditions1',
    displayName: 'Bedingungen',
    errorMessage: ErrorFormsEnum.mandatoryPlural
  },
  {
    controlName: 'acceptedConditions2',
    displayName: 'Weitere Bedingungen',
    errorMessage: ErrorFormsEnum.mandatoryPlural
  },
  {
    controlName: 'phases',
    displayName: 'Anzahl der Phasen',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'zerezId',
    displayName: 'ZEREZ-ID',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'zerezId',
    displayName: 'ZEREZ-ID',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Producer
  },
  {
    controlName: 'manufacturer',
    displayName: 'Hersteller',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'count',
    displayName: 'Anzahl',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'usableCapacity',
    displayName: 'Nutzbare Speicherkapazität',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'couplingType',
    displayName: 'Kopplungsart',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'rotaryCurrent',
    displayName: 'Stromart',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'networkAndDeviceProtection',
    displayName: 'NA-Schutz nach VDE-AR-N 4105',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Storage
  },
  {
    controlName: 'manufacturer',
    displayName: 'Hersteller des Verbrauchers',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },

  {
    controlName: 'count',
    displayName: 'Anzahl der Verbraucher',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'power',
    displayName: 'AC maximale Wirkleistung',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'chargingPointsNumber',
    displayName: 'Anzahl der Ladepunkte insgesamt',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'heatPumpType',
    displayName: 'Art der Elektro-Wärmepumpe/-Raumkühlanlage',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'powerDIN',
    displayName: 'Leistungsangabe nach DIN 8900',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'maxStartingCurrent',
    displayName: 'Max. Leistungsaufnahme',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'maxConsumptionPower',
    displayName: 'Max. Anlaufstrom',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'switchingTime',
    displayName: 'Schaltzeiten E-Heizung/Wärmepumpe/Raumkühlanlage',
    errorMessage: ErrorFormsEnum.mandatoryPlural,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'rateLimitingType',
    displayName: 'Steuerbarkeit nach §14a',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'enwgP14aModule',
    displayName: '§14a Modul',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'enwgP14aAcceptedAGBs',
    displayName: 'Zustimmung zu Allgemeinen Bedingungen §14a: ',
    errorMessage: 'Akzeptieren Sie bitte die Zustimmung zu §14a',
    step: ErrorStepsEnum.MoreInfo
  },
  {
    controlName: 'controllability',
    displayName: 'Herstellung der Steuerbarkeit',
    errorMessage: ErrorFormsEnum.mandatory,
    step: ErrorStepsEnum.Consumer
  },
  {
    controlName: 'producers',
    displayName: 'Erzeugungseinheiten',
    errorMessage: ErrorFormsEnum.mandatoryPlural,
    step: ErrorStepsEnum.None
  },
  {
    controlName: 'pvModules',
    displayName: 'PV-Module',
    errorMessage: ErrorFormsEnum.mandatoryPlural,
    step: ErrorStepsEnum.None
  },
  // Water-Actions
  {
    controlName: 'actions.ownWaterSupply',
    displayName: 'Auswahl für Eigenwasserversorgung',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'actions.isFireExtinguishingSystem',
    displayName: 'Auswahl für Feuerlöschanlage',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'actions.isDeviceReplacement',
    displayName: 'Auswahl für Gerätewechsel',
    errorMessage: ErrorFormsEnum.mandatory
  },
  {
    controlName: 'actions.isPressureBoostingSystem',
    displayName: 'Auswahl für Druckerhöhungsanlage',
    errorMessage: ErrorFormsEnum.mandatory
  }
];
